import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Account Tab</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
